
import { useContext, useEffect, useState } from 'react';
import "./dashboard.css";
import DashbaordCustomers from '../costumers_page/DashbaordCustomers.jsx';
import DisplayMyWebsite from "./DisplayMyWebsite";
import ClientContextProvider from '../../../contextApi/ClientContext';
import DashboardContextProvider from '../../../contextApi/DashboardContext';
import DashboardEditContent from './DashboardEditContent.jsx';
import DashboardEdit from './DashboardEdit.jsx';
import DashboardNavbar from './DashboardNavbar.jsx';
import DashboardHeader from '../dashboardComponents/DashboardHeader.jsx';
import { AppContext } from '../../../contextApi/ContextApi.jsx';
import DashboardProductPage from './DashboardProductPage.jsx';
import Chatbot from '../../ai/Chatbot.jsx';
import { createPortal } from 'react-dom';

export default function Dashboard({website}) { 
  const { accent_color, secondary_color, primary_color, setEditPage, editPage, setCurrentCard, currentCard, navbarArr, handleChangeActivity } = useContext(AppContext);
  const [isActive, setIsActive] = useState(website?.settings?.isActive);
  useEffect(()=>{
    setIsActive(website?.settings?.isActive);
  },[website?.settings?.isActive])

  return (
    <DashboardContextProvider>
      <div className='dashboard'>
        <DashboardHeader header={website?.settings?.website_name} theme={{accent_color, secondary_color, primary_color}}/>
        <div className='dashboard_display'>
          <DashboardNavbar website={website} editPage={editPage} setEditPage={setEditPage}/>
          {editPage === 0 ?
            <ClientContextProvider>
              <div className='dashboard_setWebsiteActivity_div'>
                <label style={{marginRight:"20px"}}>{isActive ? "האתר פעיל" : "האתר בהשהייה"}</label>
                <button className='dashboard_setWebsiteActivity_btn' style={{filter:`brightness(${isActive ? "100%" : "80%"})`}} onClick={handleChangeActivity}>
                  <div className='dashboard_setWebsiteActivity_btn_circle' style={{backgroundColor: isActive ? "green" : "red", transform: isActive ? "translateX(-5px)" : "translateX(34px)", transition:"all 0.3s ease"}}></div>
                </button>
              </div>
              <DisplayMyWebsite website={website} navbarArr={navbarArr} isActive={isActive}/>
            </ClientContextProvider> :
            editPage === 1 ? <DashboardEdit website={website} currentCard={currentCard} setCurrentCard={setCurrentCard}/> :
            editPage === 2 ? <DashbaordCustomers website={website}/> :
            editPage === 3 ? <DashboardEditContent website={website} currentCard={currentCard} setCurrentCard={setCurrentCard} setEditPage={setEditPage}/> : 
            <DashboardProductPage website={website} setEditPage={setEditPage} setCurrentCard={setCurrentCard}/>
          }
        </div>
        {/* {createPortal(<Chatbot website={website} isDashboard={true}/>, document.body)} */}
        <Chatbot website={website} isDashboard={true}/>
      </div>
    </DashboardContextProvider>
  )
}
